import React from "react";
import AccountOff from "mdi-material-ui/AccountOff";

// ASSETS
import useStyles from "./NoCustomerFound.styles";
import { useTranslation } from "react-i18next";

const NoCustomerFound = ({ notFoundMessage = "" }) => {
	const classes = useStyles();
	const { t } = useTranslation();
	return (
		<div className={classes.container}>
			<div className={classes.icon}>
				<AccountOff fontSize="inherit" />
			</div>
			<div className={classes.content}>
				<p>
					{notFoundMessage !== ""
						? notFoundMessage
						: t("customerList.table.noResultsFound")}
				</p>
			</div>
		</div>
	);
};

export default NoCustomerFound;
